import constants from '@/app-configs/constants'
import users from './users'
import Settings from './settings'
import communicationlogs from './communicationlogs'
import templates from './templates'
import apitokens from './apitokens'
import smsresponselogs from './smsresponselogs'

export default async function mainComponent() {
  const settings = await Settings()

  return [
    {
      title: 'DEBTIA_HOME',
      route: 'home',
      icon: 'HomeIcon',
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
    {
      title: 'DEBTIA_TRANSLATIONS',
      route: 'translations',
      icon: 'GridIcon',
      action: constants.action.permissionTranslationView,
      resource: constants.resource.translation,
      show: true,
    },
    {
      title: 'DEBTIA_ROLE_MANAGEMENT',
      route: 'role-management',
      icon: 'GridIcon',
      action: constants.action.permissionRoleView,
      resource: constants.resource.role,
      show: true,
    },
    ...users,
    ...settings,
    ...communicationlogs,
    ...templates,
    ...smsresponselogs,
    ...apitokens,
  ]
}
